module.exports = __webpack_public_path__ + "static/img/sharepage-btn-invite.145b548e.gif";